import React from 'react';
import PropTypes from 'prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { BADGE } from 'client/data/models/type-rankings-entities';
import { buildBadgesPath, TypeRankingsFeaturesModel } from 'client/data/models/type-rankings-features';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { Link } from 'site-modules/shared/components/link/link';

import './top-rated-ribbon.scss';

export function TopRatedRibbonUI({ vehicleParams, topRatedBadge, isMobile = false, coreEtrActivationRecipe = 'ctrl' }) {
  const BADGES = {
    [BADGE.TOP_RATED_BOB]: {
      src: {
        false: '/img/top-rated/badges/2026/gold.svg',
        true: '/img/top-rated/badges/2026/gold-black.svg',
      },
      alt: `Edmunds ${vehicleParams.year} Top Rated: Best of the Best`,
    },
    [BADGE.TOP_RATED_GAS]: {
      src: {
        false: '/img/top-rated/badges/2026/blue.svg',
        true: '/img/top-rated/badges/2026/gold-black.svg',
      },
      alt: `Edmunds ${vehicleParams.year} Top Rated: Best Gas`,
    },
    [BADGE.TOP_RATED_EV]: {
      src: {
        false: '/img/top-rated/badges/2026/teal.svg',
        true: '/img/top-rated/badges/2026/gold-black.svg',
      },
      alt: `Edmunds ${vehicleParams.year} Top Rated: Best Electric`,
    },
  };
  const badge = BADGES[topRatedBadge];

  if (!badge) {
    return null;
  }

  const isETR = coreEtrActivationRecipe.includes('chal');
  const top = isETR ? '16px' : '-8px';
  const imgWidth = isETR && isMobile ? 80 : 117;

  return (
    <Link to="/top-rated/" data-tracking-id="top_rated_badge" style={{ position: 'absolute', top, left: '16px' }}>
      <img src={getStaticImageUrl(badge.src[isETR])} alt={badge.alt} width={imgWidth} loading="lazy" />
    </Link>
  );
}

TopRatedRibbonUI.propTypes = {
  vehicleParams: PropTypes.shape({
    makeSlug: PropTypes.string,
    modelSlug: PropTypes.string,
    submodelSlug: PropTypes.string,
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  topRatedBadge: PropTypes.oneOf(Object.values(BADGE)),
  isMobile: PropTypes.bool,
  coreEtrActivationRecipe: PropTypes.string,
};

export const TopRatedRibbon = connectToModel(TopRatedRibbonUI, {
  topRatedBadge: bindToPath(
    ({ vehicleParams }) => buildBadgesPath(vehicleParams),
    TypeRankingsFeaturesModel,
    badges => badges.find(badge => Object.keys(BADGE).includes(badge))
  ),
});
